import { Button } from '@mui/material';
import { Fragment, useState } from 'react';
import ConfirmDialog from './Confirm';
import PasswordConfirmDialog from './PasswordConfirm';

interface Props {
  title: string;
  color?: string;
}

function ConfirmButton({ title, color }: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const [isPasswordOpen, setIsPasswordOpen] = useState(false);

  const onOpen = () => setIsOpen(true);
  const onClose = () => setIsOpen(false);
  const onSwitchToPasswordFind = () => setIsPasswordOpen(true);
  const onClosePassword = () => setIsPasswordOpen(false);

  return (
    <Fragment>
      <Button
        size="small"
        variant="text"
        onClick={onOpen}
        sx={{ color: color || '' }}
      >
        {title}
      </Button>

      <ConfirmDialog
        title={title}
        isOpen={isOpen}
        onClose={onClose}
        onSwitchToPasswordFind={onSwitchToPasswordFind}
      />

      <PasswordConfirmDialog
        title="Forgot password"
        isOpen={isPasswordOpen}
        onClose={onClosePassword}
      />
    </Fragment>
  );
}

export default ConfirmButton;
